module.exports = __webpack_public_path__ + "static/media/momentivehydrophilicoil.21fabaf8.png";